
















import { PowerArea, Resource as ResourceEnum } from "@gaia-project/engine";
import { InfoTableCell } from "src/logic/table/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { FastConversionEvent } from "../data/actions";
import { UiMode } from "../store";
import RichTextView from "./Resources/RichTextView.vue";
@Component({
  components: { RichTextView },
})
export default class TableCell extends Vue {
  @Prop()
  cells: InfoTableCell[];

  convert(resource: ResourceEnum | PowerArea) {
    if (resource) {
      this.$store.dispatch("fastConversionClick", { button: resource } as FastConversionEvent);
    }
  }

  get compact(): boolean {
    return this.$store.state.preferences.uiMode == UiMode.compactTable;
  }
}
